import script from "./VPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./VPopup.vue?vue&type=script&setup=true&lang=js"

import "./VPopup.vue?vue&type=style&index=0&id=5723ff47&scoped=true&lang=scss"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5723ff47"]])

export default __exports__